"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useLink_1 = require("./useLink");
Object.defineProperty(exports, "LinkProvider", { enumerable: true, get: function () { return useLink_1.LinkProvider; } });
Object.defineProperty(exports, "useLink", { enumerable: true, get: function () { return useLink_1.useLink; } });
